import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContractsComponent} from './contracts/contracts.component';
import {RouterModule} from '@angular/router';
import {EditContractsComponent} from './edit-contracts/edit-contracts.component';
import {ShowContractsComponent} from './show-contracts/show-contracts.component';
import {NxCardModule} from '@allianz/ng-aquila/card';
import {NxIconModule} from '@allianz/ng-aquila/icon';
import {ComponentsModule} from '../../components/components.module';
import {NxHeadlineModule} from '@allianz/ng-aquila/headline';
import {NxGridModule} from '@allianz/ng-aquila/grid';
import {NxButtonModule} from '@allianz/ng-aquila/button';
import {NxFormfieldModule} from '@allianz/ng-aquila/formfield';
import {NxInputModule} from '@allianz/ng-aquila/input';
import {FormsModule} from '@angular/forms';
import {NxDatefieldModule} from "@allianz/ng-aquila/datefield";
import {NxDropdownModule} from "@allianz/ng-aquila/dropdown";
import {NxMessageModule} from "@allianz/ng-aquila/message";
import {FullCalendarModule} from "@fullcalendar/angular";
import {NgApexchartsModule} from "ng-apexcharts";
import {NxSwitcherModule} from "@allianz/ng-aquila/switcher";
import {NxModalModule} from "@allianz/ng-aquila/modal";
import {PipeModule} from "../../pipe/pipe.module";

@NgModule({
  declarations: [
    ContractsComponent,
    EditContractsComponent,
    ShowContractsComponent,
  ],
    imports: [
        CommonModule,
        RouterModule,
        NxCardModule,
        NxIconModule,
        ComponentsModule,
        NxHeadlineModule,
        NxGridModule,
        NxButtonModule,
        NxFormfieldModule,
        NxInputModule,
        FormsModule,
        NxDatefieldModule,
        NxDropdownModule,
        NxMessageModule,
        FullCalendarModule,
        NgApexchartsModule,
        NxSwitcherModule,
        NxModalModule,
        PipeModule,
    ]
})
export class ContractModule {
}
